module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_12-a06203b5917b798d9021adee913855af.png";